module.exports = new __parcel__URL__("TheBrickFlixFestival.0e1f478b.avif").toString();